import { render, staticRenderFns } from "./AppContactsCustomFieldConfig.vue?vue&type=template&id=63a0bc0a&scoped=true"
import script from "./AppContactsCustomFieldConfig.vue?vue&type=script&lang=js"
export * from "./AppContactsCustomFieldConfig.vue?vue&type=script&lang=js"
import style0 from "./AppContactsCustomFieldConfig.vue?vue&type=style&index=0&id=63a0bc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0bc0a",
  null
  
)

export default component.exports